import React from 'react';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import StickySection from './StickySection';
import { H4 } from '../Text';
import { Theme } from '_lib/theme';

type Props<T> = {
  list: {
    title: string;
    content: T[];
  }[];
  renderItems: (content: T[], groupIndex: number) => React.ReactNode;
  scrollOnWindow?: boolean;
};

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    height: '100%',
    background: theme.colors.background,
  },
  scroll: {
    overflow: '-moz-scrollbars-none',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    MsOverflowStyle: 'none',

    '&::-webkit-scrollbar': {
      width: '0 !important',
    },
  },
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    width: '100%',
  },
  header: {
    width: '100%',
    boxSizing: 'border-box',

    padding: '11px 15px',
    background: '#fff',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 8px 8px 0px',
    color: '#282c37',
  },
}));

// component =================================

const StickyList = function<T>(props: Props<T>) {
  const { renderItems, list, scrollOnWindow = false } = props;
  const classes = useStyles();

  return (
    <div
      className={cx(classes.container, {
        [classes.scroll]: !scrollOnWindow,
      })}
    >
      <ul className={classes.list}>
        {list.map((listSection, i) => (
          <StickySection
            key={listSection.title}
            renderHeader={() => (
              <div className={classes.header}>
                <H4>{listSection.title}</H4>
              </div>
            )}
          >
            {renderItems(listSection.content, i)}
          </StickySection>
        ))}
      </ul>
    </div>
  );
};

export default StickyList;
